<template>
  <index_layout>
    <elink /> <template slot="ft"><mfooter :elink="true" /> </template
  ></index_layout>
</template>

<script>
import index_layout from "../_layout/index_layout";
import ELink from "./ELink";
import Footer from "../Footer";
export default {
  components: {
    index_layout: index_layout,
    elink: ELink,
    mfooter: Footer,
  },
};
</script>

<style>
</style>